import React from 'react';
import styled from 'styled-components';
import { Label, Tooltip, Icon, IconLookup } from 'component-library-and-tools';

import { LabeledContentProps } from './types';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLabel = styled(Label)`
  margin-bottom: 0.666666667rem;
  font-size: 1.166666667rem;
`;

const StyledContentContainer = styled.div``;

const LabeledContent = ({
  className,
  headerClassName,
  contentContainerClassName,
  children,
  label,
  labelClassName,
  customLabel,
  helpText,
}: LabeledContentProps) => (
  <StyledContainer className={className}>
    <StyledHeader className={headerClassName}>
      {customLabel ? customLabel : <StyledLabel className={labelClassName} text={label} />}
      {helpText && (
        <Tooltip content={helpText}>
          <Icon icon={IconLookup.QUESTION_CIRCLE} />
        </Tooltip>
      )}
    </StyledHeader>
    <StyledContentContainer className={contentContainerClassName}>
      {children}
    </StyledContentContainer>
  </StyledContainer>
);



export default LabeledContent;
